import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Section } from 'foundations-components/transitional/components/Section';
import { jsx as _jsx } from "react/jsx-runtime";
const MultipleEmailInputErrorBanner = ({
  onClose
}) => /*#__PURE__*/_jsx(Section, {
  children: /*#__PURE__*/_jsx(Alert, {
    closeable: true,
    onClose: onClose,
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputMultipleEmailV2.asyncErrorMessage"
    })
  })
});
export default MultipleEmailInputErrorBanner;